export const version = 'kunde-v1.20.0-SNAPSHOT-6405fa7b22c1f15871d6dfb89681060525ea72f1';